import { createFileRoute } from "@tanstack/react-router";

import { RootPending } from "@/components/RootPending";
import { LoginLayout } from "@/views/login/layout";

export const Route = createFileRoute("/_guest")({
  pendingComponent: RootPending,
  component: LoginLayout,
});
